import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import CopyField from "@iscr/xAppLib/UIelems/CopyField";
import { Button, Loader } from "semantic-ui-react";
import { formatBsb } from "./model";
const MASK = "••••••";
const BankDetailValue = ({ row, copy, render, }) => {
    // No profile exists for this doctor - there's nothing to mask or reveal.
    if (!row.has_profile)
        return _jsx("span", { className: "text-gray-400", children: "-" });
    const bank = row.bank;
    if (!(bank === null || bank === void 0 ? void 0 : bank.revealed))
        return _jsx("span", { className: "text-gray-400", children: MASK });
    if (bank.loading)
        return _jsx(Loader, { active: true, inline: true, size: "tiny" });
    if (bank.error || !bank.profile)
        return _jsx("span", { className: "text-red-400", children: "-" });
    const val = render(bank.profile);
    return _jsx(_Fragment, { children: copy && val ? _jsx(CopyField, { val: val, inline: true }) : val || "-" });
};
export const AccountCell = ({ row }) => (_jsx(BankDetailValue, { row: row, copy: true, render: p => p.account_number || "" }));
export const BsbCell = ({ row }) => (_jsx(BankDetailValue, { row: row, copy: true, render: p => (p.bsb ? formatBsb(p.bsb) : "") }));
export const AbnCell = ({ row }) => (_jsx(BankDetailValue, { row: row, copy: true, render: p => p.abn || "" }));
export const GstCell = ({ row }) => (_jsx(BankDetailValue, { row: row, render: p => (p.gst_registered ? "Yes" : "No") }));
export const DetailsToggleCell = ({ row, onToggleDetails, onAddProfile, }) => {
    var _a, _b, _c;
    // Nothing to reveal without a profile, so the column offers the way to create one instead.
    if (!row.has_profile) {
        if (!onAddProfile)
            return null;
        return (_jsx(Button, { basic: true, size: "small", className: "!px-2 !py-0.5", onClick: e => {
                e.stopPropagation();
                onAddProfile(row.doc_id);
            }, children: "Add profile" }));
    }
    return (_jsxs(Button, { basic: true, size: "small", disabled: (_a = row.bank) === null || _a === void 0 ? void 0 : _a.loading, className: "!py-0.5 !px-2", onClick: e => {
            e.stopPropagation();
            onToggleDetails(row.doc_id);
        }, loading: (_b = row.bank) === null || _b === void 0 ? void 0 : _b.loading, children: [((_c = row.bank) === null || _c === void 0 ? void 0 : _c.revealed) ? "Hide" : "Show", " details"] }));
};
